import React from "react";
import { Check, Circle } from "lucide-react";
import { getPasswordChecklist } from "../../utils/passwordRules";
import { THEME } from "../../theme";

const PasswordChecklist = ({ password }) => {
  const rules = getPasswordChecklist(password);

  return (
    <ul
      className="m-0 list-none space-y-1.5 p-0"
      aria-label="Password requirements"
      aria-live="polite"
    >
      {rules.map((rule) => (
        <li
          key={rule.id}
          className="flex items-center gap-2 text-[12.5px] leading-snug"
          style={{ color: rule.met ? THEME.success : THEME.text.tertiary }}
        >
          {rule.met ? (
            <Check size={14} strokeWidth={2.4} aria-hidden />
          ) : (
            <Circle size={14} strokeWidth={2} aria-hidden />
          )}
          <span>{rule.label}</span>
        </li>
      ))}
    </ul>
  );
};

export default PasswordChecklist;
